import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-mini",
  "use": "close-mini-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"close-mini\"><g stroke-width=\"1.5\" fill-rule=\"evenodd\" stroke-linecap=\"square\"><path d=\"M1.375 1.375l5.25 5.25M6.625 1.375l-5.25 5.25\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id